import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-summary-metrics',
  standalone: false,
  templateUrl: './summary-metrics.component.html',
  styleUrls: ['./summary-metrics.component.scss']
})
export class SummaryMetricsComponent implements OnInit, OnChanges {
  @Input() totalContracts: number = 0;
  @Input() totalProposals: number = 0;
  @Input() totalSubSchemes: number = 0;
  @Input() totalPreLaunch: number = 0;
  @Input() totalForLaunch: number = 0;
  @Input() totalPostLaunch: number = 0;
  @Input() completedProposals: number = 0;
  @Input() totalShortClosed: number = 0;
  @Input() labelSet: string = '';
  @Input() loading: boolean = false;

  // Add these new Inputs for scheme-wise data
  @Input() schemeWiseGrant: any = {};
  @Input() schemeWiseProposal: any = {};
  @Input() schemeWisePrelaunch: any = {};
  @Input() schemeWiseForlaunch: any = {};
  @Input() schemeWisePostlaunch: any = {};
  @Input() schemeWiseCompleted: any = {};
  @Input() schemeWiseShortClosed: any = {};

  // Add scheme orders for different cards (with defaults)
  @Input() contractSchemesOrder: string[] = ['Fauji', 'DISC', 'OC', 'ADITI'];
  @Input() proposalSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];
  @Input() preLaunchSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];
  @Input() forLaunchSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];
  @Input() postLaunchSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];
  @Input() completedSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];
  @Input() shortClosedSchemesOrder: string[] = ['Make I', 'Make II', 'Make III'];

  summaryCards: any[] = [];

  ngOnInit(): void {
    this.updateCards();
  }

  ngOnChanges(): void {
    this.updateCards();
  }

  private updateCards(): void {
    const totalContractsValue = Number(this.totalContracts) || 0;
    const totalProposalsValue = Number(this.totalProposals) || 0;
    const totalPreLaunchValue = Number(this.totalPreLaunch) || 0;
    const totalForLaunchValue = Number(this.totalForLaunch) || 0;
    const totalPostLaunchValue = Number(this.totalPostLaunch) || 0;
    const completedProposalsValue = Number(this.completedProposals) || 0;
    const totalShortClosedValue = Number(this.totalShortClosed) || 0;

    if (this.labelSet === 'make') {
      this.summaryCards = [
        { label: 'Total Contracts', count: totalContractsValue, icon: 'pi pi-file-edit', iconColor: '#2563EB', bgColor: '#EFF6FF', borderColor: '#2563EB', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseGrant, this.contractSchemesOrder) },
        { label: 'Total Proposals', count: totalProposalsValue, icon: 'pi pi-inbox', iconColor: '#059669', bgColor: '#ECFDF5', borderColor: '#059669', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseProposal, this.proposalSchemesOrder) },
        { label: 'Total On-Going Proposals (APSO Approved)', count: totalPreLaunchValue, icon: 'pi pi-clock', iconColor: '#D97706', bgColor: '#FFFBEB', borderColor: '#D97706', schemeBreakdown: this.getSchemeBreakdown(this.schemeWisePrelaunch, this.preLaunchSchemesOrder) },
        { label: 'Total On-Going Proposals (VCNS Approved)', count: totalForLaunchValue, icon: 'pi pi-send', iconColor: '#7C3AED', bgColor: '#F5F3FF', borderColor: '#7C3AED', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseForlaunch, this.forLaunchSchemesOrder) },
        { label: 'Total Short Closed Proposals', count: totalShortClosedValue, icon: 'pi pi-minus-circle', iconColor: '#6B7280', bgColor: '#F9FAFB', borderColor: '#6B7280', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseShortClosed, this.shortClosedSchemesOrder) },
        { label: 'Completed Proposals', count: completedProposalsValue, icon: 'pi pi-check-circle', iconColor: '#059669', bgColor: '#D1FAE5', borderColor: '#059669', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseCompleted, this.completedSchemesOrder) },
      ];
      return;
    }

    // Revenue scheme: 6 cards with OTE / LTE / STE category breakdown
    if (this.labelSet === 'revenue') {
      this.summaryCards = [
        { label: 'Total Proposals', count: totalProposalsValue, icon: 'pi pi-inbox', iconColor: '#0EA5E9', bgColor: '#E0F2FE', borderColor: '#0EA5E9', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseProposal, ['OTE', 'LTE', 'STE']) },
        { label: 'Total Contracts', count: totalContractsValue, icon: 'pi pi-file-edit', iconColor: '#2563EB', bgColor: '#EFF6FF', borderColor: '#2563EB', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseGrant, ['OTE', 'LTE', 'STE']) },
        { label: 'APSO Approved Proposals', count: totalPreLaunchValue, icon: 'pi pi-verified', iconColor: '#7C3AED', bgColor: '#F5F3FF', borderColor: '#7C3AED', schemeBreakdown: this.getSchemeBreakdown(this.schemeWisePrelaunch, ['OTE', 'LTE', 'STE']) },
        { label: 'Total RFP Issued Proposals', count: totalForLaunchValue, icon: 'pi pi-send', iconColor: '#D97706', bgColor: '#FFFBEB', borderColor: '#D97706', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseForlaunch, ['OTE', 'LTE', 'STE']) },
        { label: 'Short Closed Proposals', count: totalShortClosedValue, icon: 'pi pi-minus-circle', iconColor: '#64748B', bgColor: '#F1F5F9', borderColor: '#64748B', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseShortClosed, ['OTE', 'LTE', 'STE']) },
        { label: 'Completed Proposals', count: completedProposalsValue, icon: 'pi pi-check-circle', iconColor: '#059669', bgColor: '#D1FAE5', borderColor: '#059669', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseCompleted, ['OTE', 'LTE', 'STE']) },
      ];
      return;
    }

    // TDF scheme: same 6 cards as Make but no sub-schemes (TDF has no sub schemes)
    if (this.labelSet === 'tdf') {
      this.summaryCards = [
        { label: 'Total Contracts', count: totalContractsValue, icon: 'pi pi-file-edit', iconColor: '#2563EB', bgColor: '#EFF6FF', borderColor: '#2563EB', schemeBreakdown: [] },
        { label: 'Total Proposals', count: totalProposalsValue, icon: 'pi pi-inbox', iconColor: '#059669', bgColor: '#ECFDF5', borderColor: '#059669', schemeBreakdown: [] },
        { label: 'Total On-Going Proposals (APSO Approved)', count: totalPreLaunchValue, icon: 'pi pi-clock', iconColor: '#D97706', bgColor: '#FFFBEB', borderColor: '#D97706', schemeBreakdown: [] },
        { label: 'Total On-Going Proposals (VCNS Approved)', count: totalForLaunchValue, icon: 'pi pi-send', iconColor: '#7C3AED', bgColor: '#F5F3FF', borderColor: '#7C3AED', schemeBreakdown: [] },
        { label: 'Total Short Closed Proposals', count: totalShortClosedValue, icon: 'pi pi-minus-circle', iconColor: '#6B7280', bgColor: '#F9FAFB', borderColor: '#6B7280', schemeBreakdown: [] },
        { label: 'Completed Proposals', count: completedProposalsValue, icon: 'pi pi-check-circle', iconColor: '#059669', bgColor: '#D1FAE5', borderColor: '#059669', schemeBreakdown: [] },
      ];
      return;
    }

    this.summaryCards = [
      { label: 'Total Contracts', count: totalContractsValue, icon: 'pi pi-file-edit', iconColor: '#3B82F6', bgColor: '#DBEAFE', borderColor: '#3B82F6', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseGrant, this.contractSchemesOrder) },
      { label: 'Total Proposals', count: totalProposalsValue, icon: 'pi pi-inbox', iconColor: '#10B981', bgColor: '#D1FAE5', borderColor: '#10B981', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseProposal, this.proposalSchemesOrder) },
      { label: 'Total Pre-Launch Proposals', count: totalPreLaunchValue, icon: 'pi pi-clock', iconColor: '#F59E0B', bgColor: '#FEF3C7', borderColor: '#F59E0B', schemeBreakdown: this.getSchemeBreakdown(this.schemeWisePrelaunch, this.preLaunchSchemesOrder) },
      { label: 'Total For-Launch Proposals (Proposals Bank)', count: totalForLaunchValue, icon: 'pi pi-send', iconColor: '#8B5CF6', bgColor: '#E9D5FF', borderColor: '#8B5CF6', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseForlaunch, this.forLaunchSchemesOrder) },
      { label: 'Total Post-Launch Proposals', count: totalPostLaunchValue, icon: 'pi pi-check-circle', iconColor: '#06B6D4', bgColor: '#CFFAFE', borderColor: '#06B6D4', schemeBreakdown: this.getSchemeBreakdown(this.schemeWisePostlaunch, this.postLaunchSchemesOrder) },
      { label: 'Completed Proposals', count: completedProposalsValue, icon: 'pi pi-check', iconColor: '#059669', bgColor: '#A7F3D0', borderColor: '#059669', schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseCompleted, this.completedSchemesOrder) },
    ];
  }

  // Updated helper method to accept scheme order as parameter
  private getSchemeBreakdown(schemeData: any, schemeOrder: string[]): any[] {
    const data = schemeData || {};
    // When a scheme order is provided (e.g. Make I, Make II, Make III), always show all entries with counts (0 if missing)
    if (schemeOrder && schemeOrder.length > 0) {
      return schemeOrder.map(scheme => {
        const key = scheme === 'makeiii' ? 'Make III' : (scheme === 'makeii' ? 'Make II' : (scheme === 'makei' ? 'Make I' : scheme));
        return {
          schemeName: scheme,
          count: data[scheme] ?? data[key] ?? 0
        };
      });
    }
    // No order: use keys from data
    const keys = Object.keys(data);
    if (keys.length === 0) return [];
    return keys.sort().map(scheme => ({
      schemeName: scheme,
      count: data[scheme] || 0
    }));
  }
}